import { gql, TypedDocumentNode } from '@apollo/client';

export type RecommendationsQuery = {
  recommendations: {
    __typename: 'Recommendations';
    variantIds: number[];
  };
};

export type RecommendationsQueryVariables = {
  type: string;
  id: string;
  limit: number;
};

export const RECOMMENDATIONS_QUERY: TypedDocumentNode<
  RecommendationsQuery,
  RecommendationsQueryVariables
> = gql`
  query RecommendationsQuery($type: string!, $id: String!, $limit: Int!) {
    recommendations(type: $type, id: $id, limit: $limit)
      @rest(
        type: "RecentlyViewed"
        endpoint: "recommendations"
        path: "/{args.type}/{args.id}?limit={args.limit}"
      ) {
      variantIds: variant_ids
    }
  }
`;

export type DesignerAffinitiesQuery = {
  designerAffinities: {
    __typename: 'DesignerAffinities';
    top: number[];
    similar: number[];
  };
};

export type DesignerAffinitiesQueryVariables = {
  userId: string;
  limit: number;
};

export const DESIGNER_AFFINITIES_QUERY: TypedDocumentNode<
  DesignerAffinitiesQuery,
  DesignerAffinitiesQueryVariables
> = gql`
  query DesignerAffinitiesQuery($userId: String!, $limit: Int!) {
    designerAffinities(userId: $userId, limit: $limit)
      @rest(
        type: "DesignerAffinities"
        endpoint: "recommendations"
        path: "/designer_affinities/top_designers/{args.userId}?limit={args.limit}"
      ) {
      top
      similar
    }
  }
`;
